export interface Notification {
  id: number
  title: string
  message: string
  type_code: number
  type?: string
  created_at: string
  is_read: boolean
  data: Record<string, any>
  audience: number
  action_url?: string
  display_type?: NotificationDisplayType
}

export interface NotificationState {
  notifications: Notification[]
  unreadCount: number
  isConnected: boolean
  loading: boolean
  error: string | null
}

export enum NotificationType {
  DECISION_SUBMITTED = 1,
  DECISION_ADJUDICATED = 2,
  ALL_PLAYERS_JOINED = 3,
  EVENT_RELEASED = 4,
  SYSTEM_MESSAGE = 5,
}

export enum NotificationAudience {
  EVERYONE = 1,
  STAFF_ONLY = 2,
  STUDENTS_ONLY = 3,
  SPECIFIC_USER = 4,
}

export enum NotificationDisplayType {
  BELL_ICON = 1,
  POPUP_BOTTOM_RIGHT = 2,
  MODAL_CENTER_AUTO_DISMISS = 3,
}

export type NotificationVariant = 'success' | 'error' | 'warning' | 'info'
